import React from "react";

export default function Contact() {
  return (
    <div className="container mx-auto px-4 py-6">
      <div
        className="grid lg:grid-cols-1 md:grid-cols-1 gap-3 mx-auto"
        style={{ width: "80%" }}
      >
        <div className="text-right p-4  rounded">
          <p className="text-[26px] text-white">ارتباط با ما</p>
          <div className="mt-4 text-white text-justify lg:text-lg sm:text-sm">
            جهت ارتباط و تماس با اسپاد سرور راه‌های ارتباطی ما به صورت زیر
            می‌باشد. همچنین شما میتوانید ما را در کانال تلگرام و اینستاگرام
            اسپاد سرور دنبال نمایید. تمامی خبرها و تازه ترین تخفیف ها و آموزش ها
            علاوه بر سایت در شبکه های مجازی ما اطلاع رسانی خواهد شد.
          </div>
          <div className="container mx-auto p-4 mt-10">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/** Address Section */}
              <div className="flex flex-col items-center p-4 rounded">
                <div className="flex items-center justify-center mb-4">
                  <img src="images/map (3).png" className="w-12" alt="" />
                  <div className="mr-4 text-white font-bold text-md">آدرس:</div>
                </div>
                <div className="text-center">
                  <p className="text-white text-sm md:text-[12px]">
                    رشت گلسار بلوار استاد معین ساختمان اراد طبقه ۶ واحد ۹
                  </p>
                  <p className="postalCode mt-4 text-white md:text-[12px]">
                    کد پستی: ۴۱۶۶۷۳۴۵۷۲
                  </p>
                </div>
              </div>

              {/** Email Section */}
              <div className="flex flex-col items-center p-4 rounded">
                <div className="flex items-center justify-center mb-4">
                  <img src="images/gmail.png" className="w-12" alt="" />
                  <div className="mr-4 text-white font-bold text-md">
                    ایمیل:
                  </div>
                </div>
                <div className="text-center md:text-[12px]">
                  <p className="text-white">info@spadserver.com</p>
                  <p className="mt-6 text-white">spadserverco@gmail.com</p>
                </div>
              </div>

              {/** Phone Section */}
              <div className="flex flex-col items-center p-4 rounded">
                <div className="flex items-center justify-center mb-4">
                  <img src="images/phone.png" className="w-12" alt="" />
                  <div className="mr-4 text-white font-bold text-md">تلفن:</div>
                </div>
                <div className="text-center md:text-[12px]">
                  <p className="text-white">02191035943</p>
                  <p className="mt-6 text-white">01391031413</p>
                  <p className="mt-6 text-white">01391032930</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
